import {
	Component
} from '@angular/core';

@Component({
	selector: 'home',
	templateUrl: '../views/home.component.html'
})

export class HomeComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/home.component.ts